import React, { Component } from "react";
import './hStyle.css'
export default class Head extends Component {
  render() {
    return (
      <div className="cont text-center">
        <p style={{color:this.props.color,borderColor:this.props.color}} className="text h2">{this.props.text}</p>
      </div>
    );
  }
}
